<template>
  <header class="comp-navbar-e">
    <el-popover
      ref="messageBox"
      placement="bottom"
      width="350"
      trigger="click"
      v-model="messageVisible"
      :disabled="!unreadMessageInfo.totalCount">
      <div class="message-box">
        <p class="mc-title">消息中心</p>
        <ul>
          <li v-for="message in unreadMessageInfo.data">
            <a href="javascript:void(0);" class="message-title"
               @click="showDetail(message)">{{message.title.length > 23 ? message.title.slice(0, 22) + '...' :
              message.title
              }}</a>
            <img :src="icon_new" alt="mew" class="message-icon">
            <span class="message-time">{{message.publish_time}}</span>
          </li>
        </ul>
        <p class="mc-footer" @click="showMoreMessages">查看更多</p>
      </div>
    </el-popover>
    <el-row>
      <el-col :span="6">
        <img :src="logoUrl" alt="" class="nav-logo">
        <div class="sep"></div>
        <div class="service">商户中心</div>
      </el-col>
      <el-col :span="12">
        <div class="sub-header-menu">
          <div v-for="sys in sysMenus" class="system-item" :class="sys.code === activeMenu ? 'active' : ''">
            <a :href="sys.url">
              {{sys.name}}
            </a>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <ul class="account-area">
          <li class="message" v-popover:messageBox @click="goToMsgCenter">
            消息
            <span class="message-count" v-show="unreadMessageInfo.totalCount">{{unreadMessageInfo.totalCount}}</span>
          </li>
          <li class="x-line"></li>
          <li class="restaurant" :title="userInfo.belongName">
            {{userInfo.belongName}}
          </li>
          <li class="x-line"></li>
          <li>
            <div class="username">
              <el-dropdown @command="handleCommand" trigger="click">
            <span class="el-dropdown-link">
              <span class="name">欢迎你，{{userInfo.realName || userInfo.username}}</span>
              <img v-if="userInfo.weekPasswork && userInfo.userType === 0" class="guide-pwd" :src="guide_pwd_02" />
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="userInfo" v-if="isDemoUser">用户信息</el-dropdown-item>
                  <el-dropdown-item command="changePwd" v-if="isDemoUser">
                    修改密码
                    <img v-if="userInfo.weekPasswork && userInfo.userType === 0" class="guide-pwd" :src="guide_pwd_01" style="width: 14px;height: 14px;"/>
                  </el-dropdown-item>
                  <el-dropdown-item command="changePhone" v-if="isDemoUser">绑定手机号</el-dropdown-item>
                  <el-dropdown-item>退出系统</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <messageDialog ref="m_dialog" @close="closeDialog"></messageDialog>
    <el-dialog
      :title="dialogInfo.title"
      :visible.sync="dialogVisible"
      @close="close"
    >
      <div v-loading="dialogLoading">
        <iframe :src="dialogInfo.url" frameborder="0" width="100%" :height="dialogInfo.height"
                @load="dialogLoaded"></iframe>
      </div>
    </el-dialog>
  </header>
</template>

<script>
  import logoUrl from '../../assets/images/logo.png';
  import icon_new from '../../assets/images/icon-new.png';
  import guide_pwd_01 from '../../assets/images/guide-pwd-01.png';
  import guide_pwd_02 from '../../assets/images/guide-pwd-02.png';
  import messageDialog from '../MessageDialog/MessageDialog.vue';
  import {isDemoUser, isReportDemoUser} from '../../utils/demoUtils';
  import {hasType} from '../../utils/checkAgencyType';
  import {getPosVersion} from '../../utils/checkPosVersion';

  export default {
    props: ['userInfo', 'type', 'activeMenu'],
    components: {
      messageDialog
    },
    data () {
      return {
        logoUrl,
        icon_new,
        guide_pwd_01,
        guide_pwd_02,
        sysMenus: [],
        messageVisible: false,
        dialogInfo: {},
        dialogVisible: false,
        dialogLoading: false,
        unreadMessageInfo: {
          totalCount: 0,
          data: []
        },
        urgentTimer: null,
        isHQ: this.type === 'HQ' ? true : false,
        isHQPos: false
      };
    },
    created () {
      this.getUnreadMessageInfo(this.isHQ);
      this.isDemoUser = !isDemoUser(this.userInfo.hotelId, this.userInfo.username);
      if (this.type === 'HQ') {
        this.$axios.get('/hq-agency/agency/check_store_pos_version').then((res) => {
          this.isHQPos = res.data;
          this.initSys();
        });
      } else {
        const version = getPosVersion();
        this.isHQPos = version.indexOf('2.30.5') !== -1;
        this.initSys();
      }
      if (this.userInfo.weekPasswork && this.userInfo.userType === 0 && !localStorage.getItem('weakPwd')) {
        this.showChangePwd();
        localStorage.setItem('weakPwd', 'true');
      }
    },
    mounted () {
      let _this = this;
      const receiveMessage = (event) => {
        if (event.data === 'CLOSE_DIALOG') {
          _this.dialogVisible = false;
          _this.dialogInfo.url = '';
        }
      };
      window.addEventListener("message", receiveMessage, false);
      this.$nextTick(() => {
        global.vm.$on('refresh_message', (res) => {
          this.unreadMessageInfo = {
            totalCount: res.total,
            data: res.list
          };
        });
      });

      clearInterval(this.urgentTimer);
      if (this.activeMenu === 'single') {
        this.$axios.get('/irs-api/apollo-web/ces/emergency').then((res) => {
          if (res.code === 200) {
            this.urgentTimer = setInterval(this.getUrgentMessageForSingle(), 10 * 60 * 1000);
          }
        });
      } else {
        this.urgentTimer = setInterval(this.getUrgentMessage(), 10 * 60 * 1000);
      }
    },
    methods: {
      getUnreadMessageInfo () {
        let queryData = {platform: this.isHQ ? 'HQ' : 'IRS', isRead: 0, start: 0, size: 3};
        return this.$axios.post('/irs-api/ces-web/user/api/v3/message/totalList', this.$qs.stringify(queryData)).then((res) => {
          global.vm.$emit('refresh_message', res.data);
        });
      },
      close () {
        this.dialogVisible = false;
        this.dialogInfo.url = '';
      },
      showDetail (message) {
        let _this = this;
        _this.$refs.m_dialog.show(message.id, 0, false, this.isHQ);
      },
      showMoreMessages () {
        this.messageVisible = false;
        let path = '/MessageCenter';
        if (this.$route.path === path) {
          // 转到中间件来强制刷新当前 router-view
          this.$router.replace({
            path: '/Midware',
            query: {
              targetUrl: path
            }
          });
        } else {
          this.$router.push({
            path: path
          });
        }
      },
      goToMsgCenter () {
        if (this.unreadMessageInfo.totalCount === 0) {
          this.showMoreMessages();
        }
      },
      getUrgentMessage () {
        let _this = this;
        let postData = {
          platform: this.isHQ ? 'HQ' : 'IRS',
          pushType: 2
        };
        // 10分钟内没有其他ajax请求则不处理本请求（防止session不失效）
        // 排除本身请求的影响，但考虑不在拦截器做太多业务判断，所以这里判断改成9分钟
        if (+new Date() - window.previousAjaxTimeStamp > 9 * 60 * 1000) {
          return;
        }
        _this.$axios.post('/crm-api/ces-web/user/api/v3/message/notifyMessage', _this.$qs.stringify(postData)).then((res) => {
          let response = res.data;
          if (response && response.is_read === 0) {
            _this.$refs.m_dialog.show(response.id, 0, 2, this.isHQ);
          }
        });
        return _this.getUrgentMessage;
      },
      getUrgentMessageForSingle () {
        let _this = this;
        // 10分钟内没有其他ajax请求则不处理本请求（防止session不失效）
        // 排除本身请求的影响，但考虑不在拦截器做太多业务判断，所以这里判断改成9分钟
        if (+new Date() - window.previousAjaxTimeStamp > 9 * 60 * 1000) {
          return;
        }
        _this.$axios.post('/irs-web/ces/messagePush/getTopMessage', _this.$qs.stringify({pushType: 2})).then((res) => {
          let response = res.data && JSON.parse(res.data);
          if (response && response.is_read === 0) {
            _this.$refs.m_dialog.show(response.id, 0, 2);
          }
        });
        return _this.getUrgentMessageForSingle;
      },
      dialogLoaded () {
        setTimeout(() => {
          this.dialogLoading = false;
        }, 200);
      },
      handleCommand (command) {
        if (command === 'userInfo') {
          this.dialogInfo = {
            title: '用户信息',
            url: '/account-web/userInfo.html',
            height: 370
          };
          this.dialogVisible = true;
          this.dialogLoading = true;
        } else if (command === 'changePwd') {
          this.showChangePwd();
        } else if (command === 'changePhone') {
          this.dialogInfo = {
            title: '绑定手机号',
            url: '/account-web/bindPhone.html',
            height: 280
          };
          this.dialogVisible = true;
          this.dialogLoading = true;
        } else {
          localStorage.removeItem('menuList');
          localStorage.removeItem('agency_tree');
          window.location.href = "/metis-login-web/auth/logout";
        }
      },
      showChangePwd () {
        this.dialogInfo = {
          title: '修改密码',
          url: '/account-web/changePwd.html',
          height: 380
        };
        this.dialogVisible = true;
        this.dialogLoading = true;
      },
      initSys () {
        this.sysMenus = [{
          code: 'sys',
          name: '组织机构',
          url: '/org-web'
        }];
        if (this.type === 'HQ') {
          this.sysMenus = [{
            code: 'chain',
            name: '总部后台',
            url: '/hq-web/indexnew'
          }].concat(this.sysMenus);
        } else {
          this.sysMenus = [{
            code: 'single',
            name: '门店后台',
            url: '/irs-web/sso/login'
          }].concat(this.sysMenus);
        }
        if (isReportDemoUser(this.type === 'HQ' ? this.userInfo.agencyId : this.userInfo.hotelId) || this.isHQPos || this.userInfo.nativeForAndroid === true) {
          this.sysMenus.splice(1, 0, {
            code: 'crm',
            name: 'CRM管理',
            url: '/crm-web'
          });
          this.sysMenus.push({
            code: 'report',
            name: '报表中心',
            url: '/report-web'
          });
        } else {
          this.sysMenus.splice(1, 0, {
            code: 'crm',
            name: 'CRM管理',
            url: '/crm-web'
          });
        }
        if (hasType('SCM')) {
          this.sysMenus.push({
            code: 'scm',
            name: '供应链',
            url: '/scm-web-gaia'
          });
        }
      },
      closeDialog: function () {
        if (this.$route.path === '/MessageCenter') {
          this.$router.replace({
            path: '/Midware',
            query: {
              targetUrl: '/MessageCenter'
            }
          });
        }
      }
    }
  };
</script>

<style lang="less">
  header.comp-navbar-e {
    top: 0;
    left: 0;
    width: 100%;
    line-height: 60px;
    background: #016cdf;
    z-index: 2;

    .iconfont {
      cursor: pointer;
      font-size: 18px;
      padding-right: 0;
    }

    .guide-pwd {
      margin: 0;
      width: 14px;
      height: 14px;
    }

    .sub-header-menu {
      line-height: 60px;
      margin-left: 40px;
      .system-item {
        display: inline-block;
        font-size: 18px;
        opacity: 0.8;
        width: 110px;
        text-align: left;
        &.active {
          opacity: 1;
          a {
            border-bottom: 2px solid white;
            padding-bottom: 5px;
          }
        }
        a {
          cursor: pointer;
          color: #fff;
        }
      }
    }

    .nav-logo {
      width: 140px;
    }

    .account-area {
      position: fixed;
      top: 0;
      right: 0;
      padding-right: 20px;
      margin: 0;
      cursor: pointer;

      li {
        float: left;
        top: 0;
        right: 0;
        zoom: 1;
        filter: alpha(opacity=100);
        opacity: 1;
        list-style: none;
        margin-bottom: 0;
        display: inline-block;
      }
    }

    .message {
      font-size: 14px;
      color: #e5f0fb;

      .message-count {
        display: inline-block;
        min-width: 10px;
        height: 20px;
        line-height: 20px;
        background: #E94B3B;
        text-align: center;
        border-radius: 10px;
        font-size: 14px;
        transform: scale(0.8, 0.8);
        margin-left: -4px;
        padding: 0 6px 0 4px;
      }
    }

    img {
      margin: 10px 17px 13px 19px;
    }
    .sep {
      border: 1px solid white;
      width: 0;
      height: 18px;
      position: absolute;
      top: 21px;
      left: 175px;
      opacity: 0.5;
    }
    .service {
      position: absolute;
      top: 0;
      left: 193px;
      font-size: 18px;
      color: #fff;
      letter-spacing: -0.44px;
    }
    .restaurant {
      font-size: 14px;
      color: #fff;
      letter-spacing: -0.39px;
      max-width: 137px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .username {
      top: 0;
      right: 19px;
      .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .el-dropdown-link {
      color: #E5F0FB;
      font-size: 14px;
      letter-spacing: -0.44px;
    }
    .el-icon-caret-bottom:before {
      width: 8px;
      height: 5px;
    }
    .el-icon--right {
      margin-left: 0;
    }
    .account-area .x-line {
      border: 1px solid white;
      width: 0;
      height: 15px;
      opacity: 0.5;
      margin: 22px 10px;
    }
  }

  .el-popover {
    background: #ffffff;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.50);
    border-radius: 3px;
    margin-top: -10px !important;
    .message-box {
      .mc-title {
        font-size: 12px;
        font-weight: bold;
        color: #333;
        text-align: center;
        border-bottom: 2px solid #016cdf;
        padding: 12px 0;
        margin: 0;
      }
      ul {
        padding-left: 18px;
      }
      li {
        border-bottom: 1px solid #dedede;
        padding: 6px 0;
        line-height: 20px;
        .message-title {
          color: #333;
          text-decoration: none;
        }
        .message-icon {
          float: right;
          margin-right: 20px;
          width: 26px;
        }
        .message-time {
          color: #9b9b9b;
          display: block;
        }
      }
      .mc-footer {
        color: #016cdf;
        text-align: center;
        cursor: pointer;
        padding: 10px 0;
      }
    }
  }

  @media (min-width: 1101px) and (max-width: 1200px) {
    header.comp-navbar-e {
      .sub-header-menu {
        .system-item {
          width: 100px !important;
        }
      }
    }
  }

  @media (max-width: 1100px) {
    header.comp-navbar-e {
      .sub-header-menu {
        .system-item {
          width: 80px !important;
          font-size: 16px;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    header.comp-navbar-e .username {
      .name {
        max-width: 126px;
      }
    }
  }

  @media (max-width: 1200px) and (min-width: 1024px) {
    header.comp-navbar-e .restaurant {
      max-width: 100px;
    }
  }

  @media (max-width: 1100px) {
    header.comp-navbar-e .username .name {
      max-width: 100px;
    }
  }

  @media (min-width: 1101px) and (max-width: 1200px) {
    header.comp-navbar-e .username .name {
      max-width: 120px;
    }
  }

  @media (min-width: 1201px) and (max-width: 1300px) {
    header.comp-navbar-e .username .name {
      max-width: 150px;
    }
  }

</style>



// WEBPACK FOOTER //
// NavBarCRM.vue?5e65b263